import React from 'react';

const SpreadsheetContext = React.createContext(null);

export default SpreadsheetContext;
